import { render } from "./App.vue?vue&type=template&id=31e854a8&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31e854a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31e854a8', __exports__)) {
    api.reload('31e854a8', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=31e854a8&ts=true", () => {
    api.rerender('31e854a8', render)
  })

}


export default __exports__